import React from "react";
import PropTypes from "prop-types";

const COMPARISON_TREND_CONFIG = {
    UP: {
        className: "dashboard-badge-up",
        icon: "↑"
    },
    DOWN: {
        className: "dashboard-badge-down",
        icon: "↓"
    },
    NEUTRAL: {
        className: "dashboard-badge-neutral",
        icon: "•"
    }
};

const DashboardComparisonBadge = ({ comparison, formatComparison, emptyLabel }) => {
    if (!comparison) {
        return <span className="dashboard-badge dashboard-badge-neutral">{emptyLabel}</span>;
    }

    const trend = comparison.trend || "NEUTRAL";
    const trendConfig = COMPARISON_TREND_CONFIG[trend] || COMPARISON_TREND_CONFIG.NEUTRAL;

    return (
        <span className={`dashboard-badge ${trendConfig.className}`}>
            {trendConfig.icon} {formatComparison(comparison)}
        </span>
    );
};

DashboardComparisonBadge.propTypes = {
    comparison: PropTypes.shape({
        trend: PropTypes.string,
        percentageChange: PropTypes.number
    }),
    formatComparison: PropTypes.func.isRequired,
    emptyLabel: PropTypes.string
};

DashboardComparisonBadge.defaultProps = {
    comparison: null,
    emptyLabel: "-"
};

export default DashboardComparisonBadge;
